<div class="stepper" bind:clientHeight={stepperHeight}>
  <div class="step-wrap" style={`--transform-translate-x: ${step * -100}%`}>
    {#each components as comp, i (i)}
      <div class="step" class:current={i === step}>
        <svelte:component this={comp} on:complete />
      </div>
    {/each}
  </div>
</div>

<script>
  export let components = [];
  export let step = 0;
  let stepperHeight = 0;
  let shown = false;

  $: if (stepperHeight) {
    shown = true;
  }

  window.dataLayer = window.dataLayer || [];

  $: if (shown && step < 6) {
    window.dataLayer.push({ event: `FormStep${step + 1}` });
    console.log(step + 1);
  }
</script>

<style lang="postcss">
  .stepper {
    @apply overflow-hidden;
  }
  .step-wrap {
    @apply flex transform transition-transform ease-in-out duration-200;
  }
  .step {
    @apply w-full flex-shrink-0 h-0;
  }
  .step.current {
    height: initial;
  }
</style>
